<template>
  <header>
    <v-app-bar app flat color="white" style="top: inherit !important">
      <v-app-bar-nav-icon
        @click.stop="$vuetify.breakpoint.mdAndUp ? (mini = !mini) : (leftDrawer = !leftDrawer)"
      ></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <template v-if="isCreditEnabled">
        <v-menu offset-y v-model="creditsMenu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="ml-1 px-2 b-credits" v-on="on" v-bind="attrs">
              <div class="d-flex align-center">
                <span class="mr-2 text-capitalize font-weight-medium">Credits:</span>
                <div :class="['credit-wrapper']">
                  <span :class="['credit-amount', 'black--text', { 'credit-buzz': buzzCredits }]">
                    {{ companyCredits + ' €' }}
                  </span>

                  <span
                    v-if="showDiff"
                    :class="['credit-diff', diffDirection === 'up' ? 'diff-up' : 'diff-down']"
                    v-text="diffText"
                  ></span>
                </div>
                <v-icon
                  small
                  class="ml-1"
                  v-text="creditsMenu ? icons.mdiChevronUp : icons.mdiChevronDown"
                ></v-icon>
              </div>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item
              link
              @click.prevent="
                creditsMenu = false;
                topUpDialog = true;
              "
            >
              <v-list-item-title>{{ translations.topUp[lang] }}</v-list-item-title>
            </v-list-item>
            <template v-if="creditsNumeric <= 0">
              <v-tooltip color="secondary" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-on="on" v-bind="attrs" style="display: block">
                    <v-list-item disabled>
                      <v-list-item-title>{{ translations.setAutoTopUp[lang] }}</v-list-item-title>
                    </v-list-item>
                  </span>
                </template>

                <span>{{ translations.mustHaveCreditBalance[lang] }}</span>
              </v-tooltip>
            </template>

            <v-list-item
              v-else
              link
              @click.prevent="
                creditsMenu = false;
                openAutoTopUp();
              "
            >
              <v-list-item-title>{{ translations.setAutoTopUp[lang] }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <b-lang-menu v-model="lang"></b-lang-menu>

      <v-tooltip color="secondary" bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="helpDialog = true">
            <v-icon v-text="icons.mdiHelpCircleOutline"></v-icon>
          </v-btn>
        </template>

        <span class="font-weight-bold">Help</span>
      </v-tooltip>

      <!-- <AppNotifications /> -->
      <v-icon class="mr-1" v-text="icons.mdiBellOutline"></v-icon>

      <v-menu offset-y bottom transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn class="text-capitalize secondary--text" text v-on="on">
            <v-avatar size="32" class="mr-2">
              <v-img :src="user.avatar"></v-img>
            </v-avatar>
            {{ user.full_name }}
            <v-icon v-text="icons.mdiChevronDown"></v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item-group color="primary">
            <v-list-item color="blue" @click="switchAccount()">
              <v-list-item-icon class="mr-3">
                <v-icon color="blue" v-text="icons.mdiAccount"></v-icon>
              </v-list-item-icon>
              <v-list-item-title class="blue--text">{{
                translations.profile[lang]
              }}</v-list-item-title>
            </v-list-item>
            <v-list-item color="red" @click="logout">
              <v-list-item-icon class="mr-3">
                <v-icon style="margin-left: 2px" color="red" v-text="icons.mdiLogout"></v-icon>
              </v-list-item-icon>
              <v-list-item-title class="red--text">{{
                translations.logout[lang]
              }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-btn text icon @click.stop="rightDrawer = !rightDrawer">
        <CustomSvg />
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      app
      color="secondary"
      v-model="leftDrawer"
      :mini-variant="mini"
      :mini-variant-width="80"
      :temporary="$vuetify.breakpoint.smAndDown"
      :permanent="$vuetify.breakpoint.mdAndUp"
      dark
      style="top: inherit !important"
    >
      <v-list-item href="https://www.roadcube.com" class="d-block pa-3 home-link" style="">
        <v-img src="../assets/home/logo.png" class="mx-auto" width="70%" contain></v-img>
      </v-list-item>

      <v-divider></v-divider>

      <v-row class="pt-4 pb-3" no-gutters justify="center">
        <v-sheet light class="pa-2 rounded-circle">
          <v-skeleton-loader
            :loading="loading"
            type="image"
            width="50"
            height="50"
            class="rounded-circle"
          >
            <v-img :src="logo" width="50" height="50" contain class="rounded-circle"></v-img>
          </v-skeleton-loader>
        </v-sheet>

        <v-col cols="12" class="text-center mt-3">
          <v-skeleton-loader v-if="loading" type="heading" class="mx-5"></v-skeleton-loader>
          <h1 v-else class="white--text" :class="mini ? 'small-text' : 'subtitle-1'">
            {{ companyName }}
          </h1>
        </v-col>

        <v-col cols="12" class="text-center mt-3">
          <v-btn class="ma-2 text-capitalize" outlined depressed small @click="storesModal = true">
            <v-icon v-text="icons.mdiSync" />
            {{ changeStore[lang] }}
          </v-btn>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-container class="pa-0 pb-16 mb-16" :style="{ height: containerHeight, overflow: 'auto' }">
        <v-list
          v-for="navLink in navLinks"
          :key="navLink.title['en']"
          dense
          nav
          :subheader="navLink.title['en'] !== 'MANAGE'"
        >
          <v-subheader
            class="text-caption"
            :class="{ 'justify-center': mini }"
            v-text="navLink.title[lang]"
          ></v-subheader>

          <div v-for="item in navLink.children" :key="item.title['en']">
            <v-tooltip v-if="mini" color="secondary" right>
              <template v-slot:activator="{ on }">
                <v-list-item v-if="!item.hide" :to="item.to" :exact="item.exact" v-on="on">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="item.title[lang]"></v-list-item-title>
                </v-list-item>
              </template>

              <span class="font-weight-bold" v-text="item.title[lang]"></span>
            </v-tooltip>

            <v-list-item v-else-if="!item.hide" :to="item.to" :exact="item.exact">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title[lang]"></v-list-item-title>
            </v-list-item>
          </div>
        </v-list>
      </v-container>
    </v-navigation-drawer>
    <GeneralSettings v-model="rightDrawer" />

    <v-dialog v-model="helpDialog" max-width="500">
      <b-card
        title="Help"
        @cancel="helpDialog = false"
        :submitBtn="false"
        :cancel-text="{ el: '', en: 'Close', it: '' }"
      >
        <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
          <v-icon v-text="icons.mdiPhone"></v-icon>
          {{ phoneNumber }}
        </v-sheet>

        <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
          <v-icon v-text="icons.mdiEmail"></v-icon>
          {{ emailAddress }}
        </v-sheet>
      </b-card>
    </v-dialog>

    <v-dialog v-model="storesModal" max-width="500">
      <b-card
        :title="storeModalTitle[lang]"
        :loading="loading"
        @cancel="storesModal = false"
        @submit="connectStore()"
        :cancel-text="{ el: 'Κλείσιμο', en: 'Close', it: 'Chiudi' }"
        :submit-text="{ el: 'Σύνδεση', en: 'Connect', it: 'Collegare' }"
      >
        <v-col cols="12" class="d-flex justify-center">
          <UserStoresSelect v-model="storeSelect" :loading="loading" />
        </v-col>
      </b-card>
    </v-dialog>

    <v-dialog v-model="topUpDialog" max-width="480">
      <v-card>
        <v-card-title class="headline">{{ translations.buyCredits[lang] }}</v-card-title>

        <v-card-text>
          <v-text-field
            v-model="topUpAmount"
            :label="translations.amountEuro ? translations.amountEuro[lang] : 'Amount (€)'"
            inputmode="decimal"
            type="text"
            outlined
            dense
            @keypress="onAmountKeypress"
            @input="onAmountInput"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="topUpDialog = false">{{ translations.cancel[lang] }}</v-btn>
          <v-btn color="secondary" :loading="topUpLoading" @click="buyCredits">{{
            translations.purchase[lang]
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="autoTopUpDialog" max-width="520">
      <b-card
        :title="translations.setAutoTopUp[lang]"
        :loading="autoLoading || autoDeleteLoading"
        @cancel="autoTopUpDialog = false"
        @submit="saveAutoTopUp"
        @submit2="deleteConfirmDialog = true"
        :cancel-text="translations.cancel"
        :submit-text="translations.save"
        :submit-text2="translations.delete"
        :submit-btn2="autoExists"
        :btn2-color="'error'"
      >
        <v-text-field
          v-model="autoThreshold"
          :label="translations.thresholdLabel[lang]"
          inputmode="numeric"
          type="text"
          outlined
          dense
        />

        <v-text-field
          v-model="autoCap"
          :label="translations.creditAmountCap[lang]"
          inputmode="numeric"
          type="text"
          outlined
          dense
        />
      </b-card>
    </v-dialog>

    <v-dialog v-model="deleteConfirmDialog" max-width="420">
      <b-card
        type="delete"
        :title="translations.delete[lang]"
        :loading="autoDeleteLoading"
        @cancel="deleteConfirmDialog = false"
        @submit="confirmDeleteAutoTopUp"
        :cancel-text="translations.cancel"
        :submit-text="translations.delete"
      >
        <div>{{ translations.deleteAutoTopUpConfirmationMessage[lang] }}</div>
      </b-card>
    </v-dialog>
  </header>
</template>

<script>
import loyaltyPanel from '@/store/modules/loyaltyPanel';
import UserStoresSelect from '@/components/general/UserStoresSelect.vue';
import GeneralSettings from '@/components/general/settings';
import translations from '@/utils/translations/global';
import CustomSvg from '@/components/general/CustomSvg.vue';

import {
  mdiChevronDown,
  mdiChevronUp,
  mdiLogout,
  mdiCogOutline,
  mdiClose,
  mdiAccount,
  mdiHelpCircleOutline,
  mdiPhone,
  mdiEmail,
  mdiBellOutline,
  mdiSync,
  mdiMenuUp,
  mdiMenuDown,
  mdiCashMultiple,
  mdiXml,
} from '@mdi/js';

import navLinks from '@/utils/loyaltyPanel/navLinks';
import { mapActions, mapState, mapMutations } from 'vuex';
import API from '@/models/API';
// import { StripeCheckout } from '@vue-stripe/vue-stripe';

export default {
  name: 'LoyaltyHeader',

  components: { UserStoresSelect, CustomSvg, GeneralSettings },

  mixins: [navLinks, translations],

  data() {
    return {
      icons: {
        mdiChevronDown,
        mdiChevronUp,
        mdiLogout,
        mdiCogOutline,
        mdiClose,
        mdiAccount,
        mdiPhone,
        mdiEmail,
        mdiHelpCircleOutline,
        mdiBellOutline,
        mdiSync,
        mdiMenuUp,
        mdiMenuDown,
        mdiCashMultiple,
        mdiXml,
      },
      mini: false,
      creditsMenu: false,
      leftDrawer: false,
      rightDrawer: false,
      paymentErrorDialog: false,
      helpDialog: false,
      phoneNumber: '210 300 6633',
      emailAddress: 'support@roadcube.com',
      storesModal: false,
      storeSelect: null,
      topUpDialog: false,
      topUpAmount: '',
      topUpLoading: false,
      prevCreditsNumeric: null,
      buzzCredits: false,
      showDiff: false,
      diffText: '',
      diffDirection: null,
      autoTopUpDialog: false,
      autoThreshold: '',
      autoCap: '',
      autoLoading: false,
      autoDeleteLoading: false,
      autoExists: false,
      deleteConfirmDialog: false,

      changeStore: {
        el: 'Άλλαξε Κατάστημα',
        en: 'Change Store',
        it: 'Cambia Negozio',
      },
      storeModalTitle: {
        el: 'Επίλεξε κατάστημα ή επιχείρηση:',
        en: 'Select store or company:',
        it: "Seleziona il negozio o l'azienda:",
      },
    };
  },

  computed: {
    ...mapState(['user', 'storeId', 'permissions', 'storePermissions', 'superUser']),
    ...mapState('loyaltyPanel', ['stripe_pk', 'stripe_session_id', 'company']),

    lang: {
      get() {
        return this.$route.params.lang;
      },
      set(val) {
        if (val !== this.$route.params.lang)
          this.$router.push(`/${val}/` + this.$route.fullPath.slice(4));
      },
    },

    loading() {
      return this.$store.state.loyaltyPanel.loading;
    },

    logo() {
      return this.$store.state.loyaltyPanel.company.logo;
    },

    paymentError() {
      return this.$store.state.loyaltyPanel.paymentError;
    },

    companyName() {
      return this.$store.state.loyaltyPanel.company.name;
    },

    containerHeight() {
      return this.mini ? 'calc(100vh - 223px)' : 'calc(100vh - 213px)';
    },

    isCreditEnabled() {
      return Boolean(this.company?.is_credit);
    },

    companyCredits() {
      const c = this.$store.state.loyaltyPanel.company?.credits;
      const num = Number(c || 0);
      if (Number.isNaN(num)) return null;
      return num.toLocaleString(this.lang || undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    creditsNumeric() {
      return Number(this.companyCredits ?? 0);
    },
  },

  methods: {
    ...mapActions(['changeLanguage', 'getUser']),
    ...mapActions('storePanel', ['getStore']),
    ...mapActions('loyaltyPanel', [
      'getCompany',
      'topUp',
      'getAutoTopUp',
      'setAutoTopUp',
      'deleteAutoTopUp',
    ]),
    ...mapMutations(['setStoreId', 'setAccessToken', 'setNotification']),
    ...mapMutations('loyaltyPanel', ['setLoading']),

    async logout() {
      try {
        const { data } = await API.post(`/users/logout`);

        localStorage.removeItem('storeId');
        localStorage.removeItem('companyId');
        localStorage.removeItem('accessToken');
        this.setAccessToken('');
        window.location = 'https://RoadCube.com';
      } catch (ex) {
        console.log(ex.response.data);
      }
    },

    switchAccount() {
      // this.$router.push({ name: 'UserStores' })
      location.href = this.$router.resolve({ name: 'UserStores' }).href;
    },

    async payNow() {
      this.$refs.checkoutRef.redirectToCheckout();
    },

    async connectStore() {
      try {
        this.setLoading(true);
        localStorage.setItem('storeId', this.storeSelect.store_id);
        this.setStoreId(this.storeSelect.store_id);
        await this.getUser(this.storeSelect.store_id);
        if (this.storeSelect.store_type_id === 1) {
          await this.getCompany();
          this.$router.push(`/${this.lang}/loyaltyPanel`);
        } else if (this.storeSelect.store_type_id === 2) {
          console.log(this.lang, 'connectStore');
          await this.getStore();
          this.$router.push(`/${this.lang}/storePanel`);
        } else if (this.storeSelect.store_type_id === 3) {
          this.$router.push(`/${this.lang}/supplierPanel/send-reports/pending`);
        }
      } catch (ex) {
        this.setLoading(false);
        console.log(ex);
        this.errorMessage = ex.response.data.message;
        setTimeout(() => (this.errorMessage = ''), 5000);
      }
      this.storesModal = false;
      this.setLoading(false);
    },

    async buyCredits() {
      const amount = parseFloat(this.topUpAmount?.toString().replace(',', '.')) || 0;
      if (!amount || amount <= 0) {
        this.setNotification({
          show: true,
          type: 'error',
          text: this.translations.pleaseSelectAmount[this.lang],
        });
        return;
      }

      try {
        this.topUpLoading = true;
        const res = await this.topUp({ amount });
        this.setNotification({
          show: true,
          type: res.error ? 'error' : 'success',
          text: res?.message || this.translations.topUpSuccess?.[this.lang] || 'Top up successful',
        });
      } catch (ex) {
        const message = ex?.response?.data?.message || this.translations.topUpFailed?.[this.lang];
        this.setNotification({ show: true, type: 'error', text: message });
      } finally {
        this.topUpLoading = false;
        this.topUpDialog = false;
        this.topUpAmount = '';
      }
    },

    async openAutoTopUp() {
      try {
        this.autoLoading = true;
        const res = await this.getAutoTopUp();
        const payload = res?.data || res || {};

        let settings = payload?.data || payload || {};
        if (settings.auto_top_up) settings = settings.auto_top_up;
        if (settings.autoTopUp) settings = settings.autoTopUp;
        if (settings.settings) settings = settings.settings;

        const threshold = settings.threshold;
        const amount = settings.threshold_top_up_amount;

        if (threshold != null && threshold !== '') {
          this.autoExists = true;
          this.autoThreshold = String(threshold);
          this.autoCap = amount != null ? String(amount) : '';
        } else {
          this.autoExists = false;
          this.autoThreshold = '';
          this.autoCap = '';
        }

        this.autoTopUpDialog = true;
      } catch (ex) {
        this.setNotification({
          show: true,
          type: 'error',
          text: ex?.response?.data?.message || this.translations.autoTopUpSaveFailed?.[this.lang],
        });
      } finally {
        this.autoLoading = false;
      }
    },

    async saveAutoTopUp() {
      const threshold = parseFloat(this.autoThreshold?.toString().replace(',', '.')) || 0;
      const amount = parseFloat(this.autoCap?.toString().replace(',', '.')) || 0;

      if (!threshold || threshold <= 0) {
        this.setNotification({
          show: true,
          type: 'error',
          text:
            this.translations.thresholdLabel?.[this.lang] +
            ' ' +
            (this.translations.pleaseSelectAmount?.[this.lang] || ''),
        });
        return;
      }

      if (threshold > this.creditsNumeric) {
        this.setNotification({
          show: true,
          type: 'error',
          text: this.translations.mustBeLessOrEqual?.[this.lang] + ` (${this.creditsNumeric})`,
        });
        return;
      }

      if (amount < threshold) {
        this.setNotification({
          show: true,
          type: 'error',
          text: this.translations.mustBeGreaterOrEqual?.[this.lang] + ` (${threshold})`,
        });
        return;
      }

      try {
        this.autoLoading = true;
        const res = await this.setAutoTopUp({ threshold, threshold_top_up_amount: amount });
        this.setNotification({
          show: true,
          type: res.error ? 'error' : 'success',
          text: res?.message || this.translations.autoTopUpSaved?.[this.lang],
        });
        this.autoTopUpDialog = false;
      } catch (ex) {
        const message =
          ex?.response?.data?.message || this.translations.autoTopUpSaveFailed?.[this.lang];
        this.setNotification({ show: true, type: 'error', text: message });
      } finally {
        this.autoLoading = false;
      }
    },

    async confirmDeleteAutoTopUp() {
      try {
        this.autoDeleteLoading = true;
        const res = await this.deleteAutoTopUp();
        this.setNotification({
          show: true,
          type: 'success',
          text: res?.message || this.translations.autoTopUpDeleted?.[this.lang],
        });
        this.autoExists = false;
        this.autoThreshold = '';
        this.autoCap = '';
        this.deleteConfirmDialog = false;
        this.autoTopUpDialog = false;
      } catch (ex) {
        const message =
          ex?.response?.data?.message || this.translations.autoTopUpDeleteFailed?.[this.lang];
        this.setNotification({ show: true, type: 'error', text: message });
      } finally {
        this.autoDeleteLoading = false;
      }
    },

    onAmountKeypress(e) {
      const char = String.fromCharCode(e.which || e.keyCode);
      const isDigit = /[0-9]/.test(char);
      const isDot = char === '.' || char === ',';
      if (!isDigit && !isDot) {
        e.preventDefault();
        return;
      }
      if (!e.target) {
        e.preventDefault();
        return;
      }
      const val = e.target.value || '';
      const selStart = e.target.selectionStart || 0;
      const selEnd = e.target.selectionEnd || 0;

      if (isDot) {
        if (val.includes('.') || val.includes(',')) {
          e.preventDefault();
        }
        return;
      }

      const dotIndex = val.indexOf('.') !== -1 ? val.indexOf('.') : val.indexOf(',');
      if (dotIndex !== -1) {
        if (selStart > dotIndex) {
          const decimals = val.substring(dotIndex + 1);
          const selectedDecimals = Math.max(
            0,
            Math.min(selEnd, val.length) - Math.max(selStart, dotIndex + 1)
          );
          if (decimals.length - selectedDecimals >= 2) {
            e.preventDefault();
          }
        }
      }
    },

    onAmountInput(e) {
      let val = e || '';
      val = val.replace(',', '.');
      val = val.replace(/[^0-9.]/g, '');
      const parts = val.split('.');
      if (parts.length > 2) val = parts[0] + '.' + parts.slice(1).join('');
      if (val.includes('.')) {
        const [intPart, decPart] = val.split('.');
        val = intPart + '.' + (decPart || '').slice(0, 2);
      }
      this.topUpAmount = val;
    },
  },

  watch: {
    lang(val) {
      let body = {
        language_id: val == 'en' ? 1 : val == 'el' ? 2 : 3,
      };

      this.changeLanguage(body);
    },

    ['$route.path'](val) {
      if (this.paymentError && val != '/en/loyaltyPanel/general-settings/billing-dashboard') {
        this.$router.push({
          path: `/${this.lang}/loyaltyPanel/general-settings/billing-dashboard/payment-methods`,
        });
      }
    },
    'company.credits': {
      handler(val, oldVal) {
        const newNum = Number(val ?? 0);
        const hadOldCredits = oldVal !== undefined && oldVal !== null;
        const oldNum = Number(oldVal ?? this.prevCreditsNumeric ?? 0);
        if (Number.isNaN(newNum) || Number.isNaN(oldNum)) return;
        const diff = Number((newNum - oldNum).toFixed(2));
        if (!hadOldCredits || diff === 0) {
          this.prevCreditsNumeric = Number.isNaN(newNum) ? 0 : newNum;
          return;
        }

        this.buzzCredits = true;
        setTimeout(() => {
          this.buzzCredits = false;
        }, 600);

        // compute and show diff animation (separate element)
        this.diffDirection = diff > 0 ? 'up' : 'down';
        this.diffText =
          (diff > 0 ? '+' : '') +
          diff.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        this.showDiff = true;
        setTimeout(() => {
          this.showDiff = false;
        }, 1200);

        this.prevCreditsNumeric = newNum;
      },
    },
  },
  mounted() {
    if (
      this.paymentError &&
      this.$route.path != '/en/loyaltyPanel/general-settings/billing-dashboard'
    ) {
      this.$router.push({
        path: `/${this.lang}/loyaltyPanel/general-settings/billing-dashboard/payment-methods`,
      });
    }
    const initialCredits = Number(this.company?.credits ?? 0);
    this.prevCreditsNumeric = Number.isNaN(initialCredits) ? 0 : initialCredits;
  },

  beforeCreate() {
    if (!this.$store.hasModule('loyaltyPanel'))
      this.$store.registerModule('loyaltyPanel', loyaltyPanel);
  },
};
</script>

<style>
.v-skeleton-loader__heading {
  width: 100% !important;
}

.small-text {
  font-size: 10px;
}
</style>

<style scoped>
.home-link:hover {
  background-color: #1bbae1 !important;
}

::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: #2a3042;
}
.credit-amount {
  transition:
    transform 300ms ease,
    color 300ms ease;
}
.credit-animate {
  transform: scale(1);
}

.credit-wrapper {
  position: relative;
  display: inline-block;
}
.credit-diff {
  position: absolute;
  left: 12px;
  transform: translateX(-50%);
  top: 0;
  font-weight: 700;
  pointer-events: none;
}
.diff-up {
  color: #008a00;
  animation: diffUp 1s forwards ease-out;
}
.diff-down {
  color: #d32f2f;
  animation: diffDown 1s forwards ease-out;
}
@keyframes diffUp {
  0% {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -28px);
    opacity: 0;
  }
}
@keyframes diffDown {
  0% {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, 28px);
    opacity: 0;
  }
}

.credit-buzz {
  display: inline-block;
  animation: buzz 0.6s linear;
}
@keyframes buzz {
  0% {
    transform: translateX(0) rotate(0deg) scale(1.02);
  }
  20% {
    transform: translateX(-2px) rotate(-10deg) scale(0.88);
  }
  40% {
    transform: translateX(2px) rotate(10deg) scale(1.08);
  }
  60% {
    transform: translateX(-2px) rotate(-10deg) scale(0.88);
  }
  80% {
    transform: translateX(2px) rotate(0.5deg) scale(1.04);
  }
  100% {
    transform: translateX(0) rotate(0deg) scale(0.88);
  }
}

::-webkit-scrollbar-thumb {
  background: grey;
}
</style>
